import { render, staticRenderFns } from "./ModalAgregarTiendaProductoComponent.vue?vue&type=template&id=10746cf8&scoped=true&"
import script from "./ModalAgregarTiendaProductoComponent.vue?vue&type=script&lang=js&"
export * from "./ModalAgregarTiendaProductoComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModalAgregarTiendaProductoComponent.vue?vue&type=style&index=0&id=10746cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10746cf8",
  null
  
)

export default component.exports